(() => {

  // 这里是点击复制功能
  if (!customElements.get('button-toast')) {
    let activeToast;
    let activeOwner;
    let toastTimer;
    const clearToast = () => {
      clearTimeout(toastTimer);
      activeToast?.remove();
      activeToast = null;
      activeOwner = null;
    };
    customElements.define('button-toast', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (button && this.contains(button) && !button.disabled) this.activate(button);
        }, { signal: this.abort.signal });
      }
      disconnectedCallback() {
        this.abort?.abort();
        if (activeOwner === this) clearToast();
      }
      showToast(message) {
        if (!message || !this.isConnected) return;
        clearToast();
        activeOwner = this;
        activeToast = document.createElement('div');
        activeToast.className = 'button-toast__message';
        activeToast.setAttribute('role', 'status');
        activeToast.setAttribute('aria-live', 'polite');
        document.body.append(activeToast);
        activeToast.textContent = message;
        const duration = Math.max(500, Math.min(10000, Number(this.dataset.duration) || 3500));
        toastTimer = setTimeout(clearToast, duration);
      }
      async activate(button) {
        const copy = this.dataset.copy ?? button.dataset.copy;
        if (copy === undefined) {
          this.showToast(this.dataset.message);
          return;
        }
        button.disabled = true;
        if (activeOwner === this) clearToast();
        let copied = false;
        try {
          await navigator.clipboard.writeText(copy);
          copied = true;
        } catch {
          const input = document.createElement('textarea');
          input.value = copy;
          input.setAttribute('readonly', '');
          input.className = 'button-toast__clipboard';
          document.body.append(input);
          input.select();
          try { copied = document.execCommand('copy'); } catch { copied = false; }
          input.remove();
        } finally { button.disabled = false; }
        this.showToast(copied ? (this.dataset.success || 'Copied!') : (this.dataset.failure || 'Copy failed. Please copy manually.'));
      }
    });
  }



  // 这里是倒计时功能
  if (!customElements.get('black-friday-countdown')) {
    customElements.define('black-friday-countdown', class extends HTMLElement {
      connectedCallback() {
        clearInterval(this.timer);
        this.deadline = Date.parse(this.dataset.deadline);
        this.hidden = !Number.isFinite(this.deadline);
        if (this.hidden) return;
        this.tick();
        if (this.deadline > Date.now()) this.timer = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      tick() {
        const seconds = Math.max(0, Math.floor((this.deadline - Date.now()) / 1000));
        const values = { days: Math.floor(seconds / 86400), hours: Math.floor(seconds / 3600) % 24, minutes: Math.floor(seconds / 60) % 60, seconds: seconds % 60 };
        Object.entries(values).forEach(([key, value]) => {
          const node = this.querySelector(`[data-${key}]`);
          if (node) node.textContent = String(value).padStart(2, '0');
        });
        if (this.deadline <= Date.now()) clearInterval(this.timer);
      }
    });
  }

})();
